import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { BASE_URL } from "../host";
import { GET_MEDIAS, GET_MEIDAS_PAGE, POST_MEDIA } from "./Media";

function useMedia() {
  const dispatch = useDispatch();
  const { media, totalLength, pageNumber, loading } = useSelector(state => state.media);
  const fetchAllMedias = async () => {
    try {
      const res = await axios.get(BASE_URL + "news");
      dispatch({
        type: GET_MEDIAS,
        media: res.data.data,
        total_record: res.data.total_record
      });
      console.log(res.data)
    } catch (error) {
      console.log(error);
    }
  };
  const fetchByPageNumber = async pageNumber => {
    try {
      const res = await axios.post(BASE_URL + "news", {
        page_number: pageNumber
      });
      dispatch({
        type: GET_MEIDAS_PAGE,
        media: res.data.data,
        pageNumber: pageNumber
      });
    } catch (error) {}
  };

  const fetchById = async id => {
    let res;
    try {
      res = await axios.post(BASE_URL + "news", {
        id
      });
    } catch (error) {}
    return res.data.data;
  };

  // const fetchOnlyMedia = async () => {
  //   try {
  //     const res = await axios.post(BASE_URL + "news");
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  const fetchBySearch = async search => {
    let res;

    try {
      res = await axios.post(BASE_URL + "news", {
        search
      });
      
      dispatch({
        type: GET_MEDIAS,
        media: res.data.data,
        total_record: res.data.total_record
      });
    } catch (error) {
      console.log(error);
    }
  };

  const fetchByKeyword = async keyword => {
    let res;
    try {
      res = await axios.post(BASE_URL + "news", {
        keyword
      });
    } catch (error) {
      console.log(error);
    }
    return res.data.data;
  };
  const addOrUpdateMedia = async ({ title, source, img_id, content, date }) => {
    
    try {
      await axios.post(BASE_URL + "news/add", {
        title,
        source,
        date,
        img_id,
        content
      }).then(e=>console.log(e));
      dispatch({
        type: POST_MEDIA
      });
      
    } catch (error) {
      console.log(error);
      
    }
  };
  const deleteItem = async id => {
    
    try {
      const res = await axios.post(BASE_URL + "news/delete", {
        id

      });
      console.log(res)
      fetchAllMedias();
    } catch (error) {
      console.log(error);
    }
  };

  return {
    media,
    totalLength,
    pageNumber,
    loading,
    fetchAllMedias,
    fetchBySearch,
    fetchById,
    deleteItem,
    fetchByPageNumber,
    fetchByKeyword,
    addOrUpdateMedia
  };
}
export default useMedia;
